import Button from '../base/button';

import {registerMPElement} from '../../util/register-element';

import template from './index.jade';

import css from './index.styl?inline';

export default registerMPElement(`mp-button`, class extends Button {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'class': `string`,
      'color': `string`,
      'icon': `string`,
      'size': `string`,
    };
  }

  get config() {
    return Object.assign(super.config, {
      css,
      template,
    });
  }
});



// WEBPACK FOOTER //
// ../iron/common/components/button/index.js